import React, { useState, useEffect } from 'react';

export default (WrappedComponent) => {
  return (props) => {
    const items = props.items;
    const boudingMarginTop = 50;

    if (typeof window === 'undefined') {
      return null;
    }

    const [currentActiveId, setCurrentActiveId] = useState(null);
    const [currentTop, setCurrentTop] = useState(Infinity);

    useEffect(() => {
      if ('IntersectionObserver' in window) {
        const handler = (entries) => {
          for (let entry of entries) {
            if (entry.isIntersecting) {
              let id = entry.target.getAttribute('id');

              if (
                entry.boundingClientRect.top < boudingMarginTop &&
                entry.boundingClientRect.bottom > 0 &&
                id !== currentActiveId
              ) {
                setCurrentActiveId(id);
                setCurrentTop(entry.boundingClientRect.top);
              }
            }
          }
        };

        const options = {
          rootMargin: `-${boudingMarginTop}px 0px 0px 0px`,
          threshold: [0.05, 0.1, 0.15, 0.2, 0.3, 0.8, 0.9, 0.95, 0.99, 1],
        };

        items.forEach((item) => {
          let element = document.getElementById(item.Id);

          if (element) {
            let observer = new IntersectionObserver(handler, options);

            observer.observe(element);
          }
        });
      }
    }, []);

    return (
      <WrappedComponent
        currentActiveId={currentActiveId}
        currentTop={currentTop}
        {...props}
      />
    );
  };
};
